import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import useGlobal from '../../composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubsriptionForm',
  setup(__props, { expose }) {
  expose();

const { $t } = useGlobal()

const placeholder = ref("Введите ваш e-mail")
const isLoad: Ref<boolean> = ref(false)
var mailSended = ref(false)
var mailError = ref(false)
var email = ref("")
var code = ref("")

const request = (sendData: any, control: any) => {
  isLoad.value = true
  useSubmit(send(sendData), control)
}

function startTimer() {
  mailSended.value = true
}

const formatter = str => {
  return String(str).length > 1 ? str : `0${str}`
}

const send = async sendData => {
  startTimer()
  const prependedData = {
    ...sendData,
  }
  try {
    console.log(prependedData);
  } catch(e) {
    isLoad.value = false
    return Promise.reject(e)
  }
}

  
const __returned__ = { $t, placeholder, isLoad, mailSended, mailError, email, code, request, startTimer, formatter, send, ref, useSubmit, useGlobal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})